// import { Pass } from "threngine/dist/types/src/core/three-additions/additions";

import {
  WebGLRenderer,
  WebGLRenderTarget,
  Scene,
  Camera
} from "three";

export class Hotspot3DRenderPass {
  public enabled:boolean = true;

  public hotspotScene:Scene;
  public camera:Camera;

  public constructor(camera:Camera) {
    this.camera = camera;
    this.hotspotScene = new Scene();
    (this as any).needsSwap = false;
  }

  public render(
    renderer:WebGLRenderer,
    writeBuffer:WebGLRenderTarget,
    readBuffer:WebGLRenderTarget,
    deltaTime:number
  ):void {
    if (!this.enabled) {
      return;
    }

    const autoClearColorOld = renderer.autoClearColor;
    
    renderer.autoClearColor = false;
    renderer.setRenderTarget(readBuffer);
    renderer.render(this.hotspotScene, this.camera);
    renderer.autoClearColor = autoClearColorOld;
  }

  public setSize(width:number, height:number) {}
}